import { Injectable } from '@angular/core';
import { CoreQuestionsFactoryService, LocalesService } from 'core/services';
import { BehaviorSubject } from 'rxjs';
import {
  DropdownQuestion,
  HiddenQuestion,
  QuestionBase,
  QuestionGroup,
  TagsQuestion,
  TextboxQuestion
} from 'core/components';
import { UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class MarsEditorDataQuestionsService {
  protected questions: QuestionBase<any>[] = [];
  protected formData: any = {};
  protected form: UntypedFormGroup;
  protected questionsSubject = new BehaviorSubject(null);
  constructor(
    protected factory: CoreQuestionsFactoryService,
    private localesService: LocalesService,
    public translate: TranslateService
  ) {}

  getFormData(): any {}

  onDataChanged(newData: any = {}) {
    this.formData = newData;
  }

  setForm(form: UntypedFormGroup) {
    this.form = form;
  }

  getQuestionsObservable() {
    return this.questionsSubject.asObservable();
  }

  getQuestions(license, client, match) {
    return [
      new QuestionGroup({
        title: 'mars.player.editTitle',
        childQuestions: [
          new HiddenQuestion({
            key: 'id',
            value: license.id
          }),

          new TextboxQuestion({
            key: 'name',
            label: 'mars.player.name',
            value: license.name,
            order: 3
          }),
          new TextboxQuestion({
            key: 'surname',
            label: 'mars.player.surname',
            value: license.surname,
            order: 4
          }),
          new TextboxQuestion({
            key: 'email',
            label: 'mars.player.email',
            value: license.userEmail,
            editable: false,
            order: 5
          }),
          new DropdownQuestion({
            key: 'lang',
            label: 'nouns.language',
            placeholder: 'actions.selectLanguage',
            value: license.lang,
            options: this.localesService.getDefaultOptions(),
            validators: { required: true },
            order: 6
          }),
          new TextboxQuestion({
            key: 'alias',
            label: 'nouns.alias',
            value: license.alias,
            editable: true,
            order: 7
          }),
          new TagsQuestion({
            key: 'tags',
            label: 'mars.player.tags',
            value: license.tags ? license.tags.filter((playerTag) => playerTag) : license.tags,
            order: 8
          })
        ]
      })
    ];
  }
}
